import { fetchApiJson } from "utilities/fetchApiJson"

/**
 * 
 * @param {{page?: number, perPage?: number, category?: string, archiveOrder?: string[]}} params
 * @returns 
 */
export async function getCategoryArchivePracticeAreasApi(params) {
  return await fetchApiJson('/api/category-archive-practice-areas', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params),
  })
}
